// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module__link___12BPT"};